<div class="blur"></div>
<main class="container-fluid container-fluid-limited main-page">
    <div class="d-sm-flex">
        <h1 class="pt-4 pb-0 pb-sm-3 team-selector">
            <div class="team-selector-label">
                {{'moodCalendar' | translate}}
            </div>
            <tm-team-select baseUrl="/calendar" [teamIdFromUrl]="teamId"></tm-team-select>
        </h1>
        <div class="date-range-picker-wrapper">
            <tm-date-range-picker [formControl]="dateRangeCtrl" [presetIds]="presetIds" [maxDate]="maxDate"></tm-date-range-picker>
        </div>
    </div>

    <div class="row d-flex flex-row-reverse pb-5">
        <div class="col-md-3 mt-2 mt-sm-5">
            <mood-filters [tags]="all_tags" (onCallingService)="onTagSelection($event)" [calendarFilterServiceProps]="calendarFilterServiceProps"></mood-filters>
        </div>
        <div class="col-md-9">

            <div class="row">
                <announcement header="{{'calendar.announcement.header' | translate}}"
                              body="{{'calendar.announcement.body' | translate}}"></announcement>
            </div>

            @if(moodsDisplayTime){
                <div class="alert alert-warning">
                    {{ "todays_moods" | translate}} {{moodsDisplayTime.time}} ( {{moodsDisplayTime.timeZone}} )
                </div>
            }
            
            <!-- <no-moods-component no-moods="moods.length === 0"></no-moods-component> -->

            @if(days){
                <div class="row mb-4 mt-5 mt-md-0">
                    <tm-moods-distribution-bar [moods]="moodsToCount"></tm-moods-distribution-bar>
                </div>
            }
            
            @if(days){
                <table class="table table-hover moods-table">
                    <thead>
                        <tr>
                            <th><span class="ps-2">{{'date' | translate}}</span></th>
                            <th>{{'moods' | translate}}</th>
                        </tr>
                    </thead>
    
                    <tbody>
                        @if(days.length === 0){
                            <tr>
                                <td></td>
                                <td class="w-auto">{{'no_moods_filter' | translate }}</td>
                            </tr>
                        }
                        
                        @for(day of days; track day){
                            <tr [ngClass]="{info: day.today}">
                                <td class="align-middle w-25">
                                    <p class="ps-2">{{day.date}}</p>
                                </td>
                                <td class="pt-3">
                                    @for(value of day.values; track value){
                                        <span class="dailyMood">
                                            <mood [value]="value"></mood>
                                        </span>
                                    }
                                </td>
                            </tr>  
                        }
                    </tbody>
                </table>
            }
        </div>
    </div>
</main>